<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    width=650
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
    style="overflow: auto;padding-bottom: 53px;">

    <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
      <a-input-search v-model="searchAreaValue" style="width:100%;margin-top: 10px" :placeholder="$t('请输入知识库名称')"/>
      <!-- 树-->
      <a-row>
        <a-col :md="24" :sm="24" style="max-height: 60vh;overflow: auto">
          <template>
            <a-spin tip="Loading..." :spinning="areaLoading">
              <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  :default-expand-all="false"
                  @node-click="nodeClick"
                  @node-collapse="nodeCollapse"
                  ref="areaTree">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span class="tree-node-title">{{ node.label }}</span>
                  </span>
                </el-tree>
            </a-spin>
          </template>
        </a-col>
      </a-row>
      <a-row v-if="form.id">
        <div class="content-box">
          <div class="item">
            <div class="label">{{ $t('知识内容：') }}</div>
            <div class="content">
              <j-editor v-model="form.content" :disabled="true" toolbar=""></j-editor>
            </div>
          </div>
          <div class="item">
            <div class="label">{{ $t('内容附件：') }}</div>
            <div class="content">
              <JUpload v-model="fileList" :buttonVisible="false" v-if="fileList.length>0"/>
              <i v-else>{{ $t('暂无附件') }}</i>
            </div>
          </div>
          <!-- <a-form-model ref="formModal" :model="form":colon="false">
            <a-col :span="24">
              <a-form-model-item label="知识内容" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="content">
                <a-textarea v-model="form.content" rows="8" placeholder="请输入知识内容"/>
                {{form.content}}
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="内容附件" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <JUpload v-model="fileList" :buttonVisible="false" v-if="fileList.length>0"/>
                <i v-else>暂无附件</i>
              </a-form-model-item>
            </a-col>
          </a-form-model> -->
        </div>
      </a-row>
    </div>
  </a-drawer>
</template>
<script>
  import {queryTreeListForRole,queryRolePermission,saveRolePermission} from '@/api/api'
  import {httpAction, deleteAction,getAction} from '@/api/manage'
  import JUpload from '@/components/jeecg/JUpload'
  import JEditor from '@/components/jeecg/JEditor'
  export default {
    name: "KnowledgeBaseQuery",
    components:{JUpload,JEditor},
    data(){
      return {
        roleId:"",
        treeData: [],
        areaTree: [],
        defaultCheckedKeys:[],
        checkedKeys:[],
        expandedKeysss:[],
        allTreeKeys:[],
        autoExpandParent: true,
        checkStrictly: true,
        visible: false,
        loading: false,
        selectedKeys:[],
        url: {
          queryAreaTreeList: "/jeecg-hotline/knowledge/knowledge/queryAreaTreeList",
          edit: "/jeecg-hotline/knowledge/knowledge/edit",
          delete: "/jeecg-hotline/knowledge/knowledge/delete",
          queryById: "/jeecg-hotline/knowledge/knowledge/queryById",
        },
        searchAreaValue: '',
        form: {},
        areaLoading: false,
        defaultProps: {
          children: 'children',
          label: 'knowledgeName'
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        fileList: [],
        currentNodeKey:null,
        iExpandedKeys: [],
        checkStrictly: true,
      }
    },
    watch: {
      searchAreaValue(val) {
        this.$refs.areaTree.filter(val);
        if(val){
          this.$nextTick(() => {
            this.changeTreeNodeStatus(this.$refs.areaTree.store.root);
          });
        }
      },
      visible () {
        if (this.visible) {
          this.loadTree();
        }
      }
    },
    // i18n：标题使用 computed 以响应语言切换
    computed: {
      title() {
        return this.$t('知识库查询');
      }
    },
    methods: {
      changeTreeNodeStatus(node) {// 搜索tree后只展开到当前搜索一级
        node.expanded = false;
        for (let i = 0; i < node.childNodes.length; i++) {
          node.childNodes[i].expanded = false;
          if(node.childNodes[i].data.knowledgeName.indexOf(this.searchAreaValue)>-1){
            node.childNodes[i].expanded = true;
            node.expanded = true;
          }
          if (node.childNodes[i].childNodes.length > 0) {
            node.expanded = true;
            // node.childNodes[i].expanded = true;
            this.changeTreeNodeStatus(node.childNodes[i]);
          }
        }
      },
      loadTree() {
        this.areaLoading = true
        var that = this
        that.treeData = []
        that.areaTree = []
        getAction(this.url.queryAreaTreeList).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
              that.areaTree.push(temp)
              that.setThisExpandedKeys(temp)
            }
            
          }
        }).finally(()=> {
          this.areaLoading = false
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.id)
        }
      },
      show(){
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      nodeClick(record,node,data) {
        // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
        if(node.checked) {
          this.currentNodeKey = record.id
          this.$refs.areaTree.setCheckedKeys([record.id])
          this.setValuesToForm(record)
        }else{
          this.currentNodeKey = null
          this.currSelected = {};
        }
        this.fileList = [];
      },
      setValuesToForm(record) {
        getAction(this.url.queryById,{id:record.id}).then(res=>{
          if(res.success){
            let data = res.result;
            this.form = data;
            this.$set(this.form,'content',data.knowledgeItem.content);
            this.$set(this.form,'contentAnnex',data.knowledgeItem.contentAnnex);
            if(data.knowledgeItem.contentAnnex) this.fileList = [data.knowledgeItem.contentAnnex];
          }
        });
      },
      filterNode(value, data, node) {
        // if (!value) return true;
        // return data.areaName.indexOf(value) !== -1;
        let parentNode = node.parent // 父级node
        let labels = [node.label] // 当前node的名字
        let level = 1 // 层级
        while (level < node.level) {
            labels = [...labels, parentNode.label] // 当前node名字，父级node的名字
            parentNode = parentNode.parent
            level++
        }
        return labels.some(d => d.indexOf(value) !== -1)
      },
      nodeCollapse(data,node,el){
        this.form = {};
      }
    },
  }

</script>
<style lang="less" scoped>
  .drawer-bootom-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
  .content-box{
    margin-top: 30px;
    border: 1px dashed #999;
    padding: 10px;
    border-radius: 8px;
    .item{
      display: flex;
      margin-bottom: 20px;
      .label{
        width: 100px;
        text-align: right;
      }
      .content{
        flex: 1;
      }
    }
  }

</style>